import React from 'react';
import { MobileLayout } from '../components/MobileLayout';
import { User, Bell, Lock, CreditCard, Globe, HelpCircle } from 'lucide-react';
export function ImpostazioniPage() {
  return <MobileLayout data-id="element-1348">
      {/* Page Header */}
      <div className="mb-6 lg:mb-8" data-id="element-1349">
        <h1 className="text-xl lg:text-2xl font-bold text-navy" data-id="element-1350">
          Impostazioni
        </h1>
        <p className="text-xs lg:text-sm text-gray-500 mt-1" data-id="element-1351">
          Gestisci le preferenze del tuo account
        </p>
      </div>

      {/* Settings Sections */}
      <div className="space-y-4" data-id="element-1352">
        {/* Account Section */}
        <div className="bg-white rounded-xl border border-gray-200 p-4 lg:p-6" data-id="element-1353">
          <h2 className="text-sm font-semibold text-navy mb-4 flex items-center gap-2" data-id="element-1354">
            <User size={18} data-id="element-1355" />
            Account
          </h2>
          <div className="space-y-3" data-id="element-1356">
            <button className="w-full flex items-center justify-between p-3 hover:bg-gray-50 rounded-lg transition-colors text-left min-h-[44px]" data-id="element-1357">
              <span className="text-sm text-navy" data-id="element-1358">Profilo</span>
              <span className="text-xs text-gray-400" data-id="element-1359">›</span>
            </button>
            <button className="w-full flex items-center justify-between p-3 hover:bg-gray-50 rounded-lg transition-colors text-left min-h-[44px]" data-id="element-1360">
              <span className="text-sm text-navy" data-id="element-1361">Email e Password</span>
              <span className="text-xs text-gray-400" data-id="element-1362">›</span>
            </button>
          </div>
        </div>

        {/* Notifications Section */}
        <div className="bg-white rounded-xl border border-gray-200 p-4 lg:p-6" data-id="element-1363">
          <h2 className="text-sm font-semibold text-navy mb-4 flex items-center gap-2" data-id="element-1364">
            <Bell size={18} data-id="element-1365" />
            Notifiche
          </h2>
          <div className="space-y-3" data-id="element-1366">
            <button className="w-full flex items-center justify-between p-3 hover:bg-gray-50 rounded-lg transition-colors text-left min-h-[44px]" data-id="element-1367">
              <span className="text-sm text-navy" data-id="element-1368">Preferenze Notifiche</span>
              <span className="text-xs text-gray-400" data-id="element-1369">›</span>
            </button>
          </div>
        </div>

        {/* Security Section */}
        <div className="bg-white rounded-xl border border-gray-200 p-4 lg:p-6" data-id="element-1370">
          <h2 className="text-sm font-semibold text-navy mb-4 flex items-center gap-2" data-id="element-1371">
            <Lock size={18} data-id="element-1372" />
            Sicurezza
          </h2>
          <div className="space-y-3" data-id="element-1373">
            <button className="w-full flex items-center justify-between p-3 hover:bg-gray-50 rounded-lg transition-colors text-left min-h-[44px]" data-id="element-1374">
              <span className="text-sm text-navy" data-id="element-1375">
                Autenticazione a due fattori
              </span>
              <span className="text-xs text-gray-400" data-id="element-1376">›</span>
            </button>
          </div>
        </div>

        {/* Billing Section */}
        <div className="bg-white rounded-xl border border-gray-200 p-4 lg:p-6" data-id="element-1377">
          <h2 className="text-sm font-semibold text-navy mb-4 flex items-center gap-2" data-id="element-1378">
            <CreditCard size={18} data-id="element-1379" />
            Fatturazione
          </h2>
          <div className="space-y-3" data-id="element-1380">
            <button className="w-full flex items-center justify-between p-3 hover:bg-gray-50 rounded-lg transition-colors text-left min-h-[44px]" data-id="element-1381">
              <span className="text-sm text-navy" data-id="element-1382">Metodi di Pagamento</span>
              <span className="text-xs text-gray-400" data-id="element-1383">›</span>
            </button>
            <button className="w-full flex items-center justify-between p-3 hover:bg-gray-50 rounded-lg transition-colors text-left min-h-[44px]" data-id="element-1384">
              <span className="text-sm text-navy" data-id="element-1385">Storico Fatture</span>
              <span className="text-xs text-gray-400" data-id="element-1386">›</span>
            </button>
          </div>
        </div>

        {/* Language Section */}
        <div className="bg-white rounded-xl border border-gray-200 p-4 lg:p-6" data-id="element-1387">
          <h2 className="text-sm font-semibold text-navy mb-4 flex items-center gap-2" data-id="element-1388">
            <Globe size={18} data-id="element-1389" />
            Lingua e Regione
          </h2>
          <div className="space-y-3" data-id="element-1390">
            <button className="w-full flex items-center justify-between p-3 hover:bg-gray-50 rounded-lg transition-colors text-left min-h-[44px]" data-id="element-1391">
              <span className="text-sm text-navy" data-id="element-1392">Lingua</span>
              <span className="text-xs text-gray-500" data-id="element-1393">Italiano</span>
            </button>
          </div>
        </div>

        {/* Help Section */}
        <div className="bg-white rounded-xl border border-gray-200 p-4 lg:p-6" data-id="element-1394">
          <h2 className="text-sm font-semibold text-navy mb-4 flex items-center gap-2" data-id="element-1395">
            <HelpCircle size={18} data-id="element-1396" />
            Supporto
          </h2>
          <div className="space-y-3" data-id="element-1397">
            <button className="w-full flex items-center justify-between p-3 hover:bg-gray-50 rounded-lg transition-colors text-left min-h-[44px]" data-id="element-1398">
              <span className="text-sm text-navy" data-id="element-1399">Centro Assistenza</span>
              <span className="text-xs text-gray-400" data-id="element-1400">›</span>
            </button>
            <button className="w-full flex items-center justify-between p-3 hover:bg-gray-50 rounded-lg transition-colors text-left min-h-[44px]" data-id="element-1401">
              <span className="text-sm text-navy" data-id="element-1402">Contattaci</span>
              <span className="text-xs text-gray-400" data-id="element-1403">›</span>
            </button>
          </div>
        </div>

        {/* Logout Button */}
        <button className="w-full px-4 py-3 border border-red-200 text-red-600 rounded-lg hover:bg-red-50 transition-colors text-sm font-medium min-h-[44px]" data-id="element-1404">
          Esci dall'Account
        </button>
      </div>
    </MobileLayout>;
}